// extracted by mini-css-extract-plugin
module.exports = {"root":"_ee8d83","playButton":"_f88b3d","playButtonYT":"_af9834","caption":"_1557fc"};